import React from 'react';
import styled from 'styled-components';
import { Select } from '@carvana/showroom-forms/Select';

type SelectProps = Omit<React.ComponentProps<typeof Select>, 'onChange'>;

type LanguageSelectProps = SelectProps & {
  onChange: React.ChangeEventHandler<HTMLSelectElement>;
};

export const LanguageSelect: React.FC<LanguageSelectProps> = styled(Select)`
  background: var(--cvna-color-grey-1);

  span {
    font-weight: bold !important;
  }
`;
